import React from 'react'
import { useIntl } from 'react-intl'

import SearchIcon from 'client/icons/Search'
import styles from './styles.module.css'

export function NoResults() {
  const intl = useIntl()

  return (
    <div className={styles.noResultsContainer}>
      <SearchIcon size={30} />
      <span className={styles.noResultsText}>
        {intl.formatMessage({ id: 'global.no-results' })}
      </span>
      <span className={styles.modifySearchText}>
        {intl.formatMessage({ id: 'global.modify-search' })}
      </span>
    </div>
  )
}
